import React, { useEffect } from 'react';
import MainGroup from './components/main_group/MainGroup';
import TopGroup from './components/top_group/TopGroup';
import ButtonGroup from './components/button_group/ButtonGroup';
import { useDispatch, useSelector } from 'dva';
import { useLocation } from 'umi';

const CrowdPortrayal = () => {
  const location = useLocation();
  const { groupId } = location.query;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: 'crowPortrayal/profileGroupTag',
      payload: {
        values: {
          groupId,
        },
      },
    });
  }, [dispatch, groupId]);
  const { groupInfo } = useSelector((state) => state.crowPortrayal);
  return (
    <div
      data-log={JSON.stringify({
        oid: 'page_user_profile_management_image',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <TopGroup groupInfo={groupInfo}></TopGroup>
      <MainGroup list={groupInfo?.profileGroupTag}></MainGroup>
      <ButtonGroup />
    </div>
  );
};

export default CrowdPortrayal;
